import cloudflareAssets from "@/assets/cloudflareAssets";
import { AccessManagementKeys, AppPaths, Currencies, DownloadType } from "@/shared/common/enums";
import type { ICurrency, IOption } from "@/shared/common/types";
import {
  AEDSymbolIcon,
  AMDSymbolIcon,
  AUDSymbolIcon,
  CADSymbolIcon,
  CHFSymbolIcon,
  CNYSymbolIcon,
  EURSymbolIcon,
  GBPSymbolIcon,
  GELSymbolIcon,
  INDSymbolIcon,
  JPYSymbolIcon,
  KRWSymbolIcon,
  RUBSymbolIcon,
  SEKSymbolIcon,
  USDSymbolIcon,
} from "@/shared/components/SvgIcons";

export const OTP_COUNT = 6;

export const LOGIN_OTP_COUNT = 6;

export const CARD_NUMBER_LENGTH = 16;

export const PHONE_REGEX = /^\+?\d{6,14}$/;

export const CURRENCY: { [key: string]: ICurrency } = {
  [Currencies.USD]: {
    symbol: "$", flag: cloudflareAssets.USA, symbolIcon: USDSymbolIcon, label: Currencies.USD
  },
  [Currencies.EUR]: {
    symbol: "€", flag: cloudflareAssets.EUR, symbolIcon: EURSymbolIcon, label: Currencies.EUR
  },
  [Currencies.GBP]: {
    symbol: "£", flag: cloudflareAssets.GBR, symbolIcon: GBPSymbolIcon, label: Currencies.GBP
  },
  [Currencies.AMD]: {
    symbol: "֏", flag: cloudflareAssets.ARM, symbolIcon: AMDSymbolIcon, label: Currencies.AMD
  },
  [Currencies.RUB]: {
    symbol: "₽", flag: cloudflareAssets.RUS, symbolIcon: RUBSymbolIcon, label: Currencies.RUB
  },
  [Currencies.JPY]: {
    symbol: "¥", flag: cloudflareAssets.JPN, symbolIcon: JPYSymbolIcon, label: Currencies.JPY
  },
  [Currencies.INR]: {
    symbol: "₹", flag: cloudflareAssets.IND, symbolIcon: INDSymbolIcon, label: Currencies.INR
  },
  [Currencies.CNY]: {
    symbol: "¥", flag: cloudflareAssets.CHN, symbolIcon: CNYSymbolIcon, label: Currencies.CNY
  },
  [Currencies.KRW]: {
    symbol: "₩", flag: cloudflareAssets.KOR, symbolIcon: KRWSymbolIcon, label: Currencies.KRW
  },
  [Currencies.SEK]: {
    symbol: "kr", flag: cloudflareAssets.SWE, symbolIcon: SEKSymbolIcon, label: Currencies.SEK
  },
  [Currencies.CHF]: {
    symbol: "₣", flag: cloudflareAssets.CHE, symbolIcon: CHFSymbolIcon, label: Currencies.CHF
  },
  [Currencies.CAD]: {
    symbol: "C$", flag: cloudflareAssets.CAN, symbolIcon: CADSymbolIcon, label: Currencies.CAD
  },
  [Currencies.AUD]: {
    symbol: "", flag: cloudflareAssets.AUS, symbolIcon: AUDSymbolIcon, label: Currencies.AUD
  },
  [Currencies.AED]: {
    symbol: "د.إ", flag: cloudflareAssets.ARE, symbolIcon: AEDSymbolIcon, label: Currencies.AED
  },
  [Currencies.GEL]: {
    symbol: "₾", flag: cloudflareAssets.GEL, symbolIcon: GELSymbolIcon, label: Currencies.GEL
  },
  [Currencies.XAU]: {
    symbol: "", flag: cloudflareAssets.XAU, symbolIcon: "", label: Currencies.XAU
  },
  [Currencies.BHD]: {
    symbol: "ب.د", flag: "", symbolIcon: "", label: Currencies.BHD
  },
  [Currencies.PLN]: {
    symbol: "zł", flag: "", symbolIcon: "", label: Currencies.PLN
  }
};

export const OperationRoutes: { [key: string]: AppPaths } = {
  AccountTransfer: AppPaths.AccountTransfer,
  AccountTransferUpdate: AppPaths.AccountTransferUpdate,
  AccountTransferCopy: AppPaths.AccountTransferCopy,
  CardTransfer: AppPaths.CardTransfer,
  CardTransferUpdate: AppPaths.CardTransferUpdate,
  CardTransferCopy: AppPaths.CardTransferCopy,
  OwnAccountTransfer: AppPaths.OwnAccountTransfer,
  OwnAccountTransferUpdate: AppPaths.OwnAccountTransferUpdate,
  OwnAccountTransferCopy: AppPaths.OwnAccountTransferCopy,
  BudgetTransfer: AppPaths.BudgetTransfer,
  BudgetTransferUpdate: AppPaths.BudgetTransferUpdate,
  BudgetTransferCopy: AppPaths.BudgetTransferCopy,
  CurrencyExchange: AppPaths.CurrencyExchange,
  CurrencyExchangeUpdate: AppPaths.CurrencyExchangeUpdate,
  CurrencyExchangeCopy: AppPaths.CurrencyExchangeCopy,
  GroupTransfer: AppPaths.GroupTransfer,
  GroupTransferUpdate: AppPaths.GroupTransferUpdate,
  GroupTransferCopy: AppPaths.GroupTransferCopy,
  AccountOpeningApplication: AppPaths.AccountOpeningApplication,
  AccountOpeningApplicationUpdate: AppPaths.AccountOpeningApplicationUpdate,
  AccountOpeningApplicationCopy: AppPaths.AccountOpeningApplicationCopy,
  AccountClosureApplication: AppPaths.AccountClosureApplication,
  AccountClosureApplicationUpdate: AppPaths.AccountClosureApplicationUpdate,
  AccountClosureApplicationCopy: AppPaths.AccountClosureApplicationCopy,
  PhoneBankingApplication: AppPaths.PhoneBankingApplication,
  PhoneBankingApplicationUpdate: AppPaths.PhoneBankingApplicationUpdate,
  PhoneBankingApplicationCopy: AppPaths.PhoneBankingApplicationCopy,
  PayrollCardOpeningApplication: AppPaths.PayrollCardOpeningApplication,
  PayrollCardOpeningApplicationUpdate: AppPaths.PayrollCardOpeningApplicationUpdate,
  PayrollCardOpeningApplicationCopy: AppPaths.PayrollCardOpeningApplicationCopy,
  PeriodicalPaymentsApplication: AppPaths.PeriodicalPaymentsApplication,
  PeriodicalPaymentsApplicationUpdate: AppPaths.PeriodicalPaymentsApplicationUpdate,
  PeriodicalPaymentsApplicationCopy: AppPaths.PeriodicalPaymentsApplicationCopy,
  CardServiceInstructionApplication: AppPaths.CardServiceInstructionApplication,
  CardServiceInstructionApplicationUpdate: AppPaths.CardServiceInstructionApplicationUpdate,
  CardServiceInstructionApplicationCopy: AppPaths.CardServiceInstructionApplicationCopy,
  LoanTrancheDisbursementApplication: AppPaths.LoanTrancheDisbursementApplication,
  LoanTrancheDisbursementApplicationUpdate: AppPaths.LoanTrancheDisbursementApplicationUpdate,
  LoanTrancheDisbursementApplicationCopy: AppPaths.LoanTrancheDisbursementApplicationCopy,
  DepositTerminationApplication: AppPaths.DepositTerminationApplication,
  DepositTerminationApplicationUpdate: AppPaths.DepositTerminationApplicationUpdate,
  DepositTerminationApplicationCopy: AppPaths.DepositTerminationApplicationCopy,
  UserOpeningApplication: AppPaths.UserOpeningApplication,
  UserOpeningApplicationUpdate: AppPaths.UserOpeningApplicationUpdate,
  UserOpeningApplicationCopy: AppPaths.UserOpeningApplicationCopy,
  LoanRepayment: AppPaths.LoanRepayment,
  LoanRepaymentUpdate: AppPaths.LoanRepaymentUpdate,
  LoanRepaymentCopy: AppPaths.LoanRepaymentCopy,
  AccountTransferTemplate: AppPaths.AccountTransferTemplate,
  AccountTransferTemplateUpdate: AppPaths.AccountTransferTemplateUpdate,
  CardTransferTemplate: AppPaths.CardTransferTemplate,
  CardTransferTemplateUpdate: AppPaths.CardTransferTemplateUpdate,
  OwnAccountTransferTemplate: AppPaths.OwnAccountTransferTemplate,
  OwnAccountTransferTemplateUpdate: AppPaths.OwnAccountTransferTemplateUpdate,
  CurrencyExchangeTemplate: AppPaths.CurrencyExchangeTemplate,
  CurrencyExchangeTemplateUpdate: AppPaths.CurrencyExchangeTemplateUpdate,
  LoanRepaymentTemplate: AppPaths.LoanRepaymentTemplate,
  LoanRepaymentTemplateUpdate: AppPaths.LoanRepaymentTemplateUpdate,
  BudgetTransferTemplate: AppPaths.BudgetTransferTemplate,
  BudgetTransferTemplateUpdate: AppPaths.BudgetTransferTemplateUpdate,
};

export const AMERIA_PREFIX = "15700";
export const BUDGET_ACCOUNT_PREFIX = "9000";

export const NUMBER_REGEX = new RegExp("^[0-9]+$");

export const ONLY_DIGITS = new RegExp(/^\d+$/);

export const MESSAGE_VALIDATION = ["REN/", "PDD/", "PD2/", "PND/", "PDC/", "MOC/", "NAM/", "CPO/", "INV/", "IPI/", "RFB/", "ROC/", "REC/"];

export const ACCEPTED_ALPHANUMERIC_REGEX = /^[0-9A-Za-zԱ-Ֆա-ֆև(){}=;,%*./\-_?!:։"+'~@#$^«»“”\]\s]*$/;
export const BENEFICIARY_NAME_REGEX = /^[0-9A-Za-zԱ-Ֆա-ֆև(){}=;,%*./\-_?!:։+'‘’"№~@#$^«»“”&\[\]\s]*$/;
export const TEXT_FIELD_VALIDATION_REGEX = /^[0-9A-Za-z\u0531-\u058F(){}=;№%,*.\-_\/?!':+~@#$^\[\]\s]+$/;
export const LATIN_NUMERIC_REGEX = /^[a-zA-Z0-9]+$/;

export const INPUT_MAX_LIMIT = 140;
export const INPUT_MIN_LIMIT = 5;

export const DATE_FORMAT = {
  DD_MM_YYYY: "DD/MM/YYYY",
  dd_MM_yyyy: "dd/MM/yyyy",
  YYYY_MM_DD: "YYYY-MM-DD",
  DEFAULT: "DD.MM.YYYY",
  DD_MMM_YYYY: "DD MMM, YYYY",
  MM: "MM",
  YY: "YY",
};

export const CARD_FORMAT = "XXXX XXXX XXXX XXXX";
export const ACCOUNT_FORMAT = "XXXXXXXXXXXXXXXX";

export const CARD_TRANSFER_MAX_AMOUNT = 399000;
export const CARD_TRANSFER_MIN_AMOUNT = 100;
export const MAX_AMOUNT = 9999999999.9;

export const INITIAL_PAGE = 1;
export const INITIAL_PAGE_SIZE = 1000;
export const INITIAL_TABLE_PAGE_SIZE = 10;

export const OTP_PATTERN = "[0-9]*";

export const AllowedAccountTransferCurrencies = [Currencies.USD, Currencies.AMD, Currencies.EUR];

export const PageSizeOptions: IOption[] = [
  {
    value: "10",
    label: "10",
  },
  {
    value: "20",
    label: "20",
  },
  {
    value: "30",
    label: "30",
  },
  {
    value: "40",
    label: "40",
  },
  {
    value: "50",
    label: "50",
  },
];

export const DownloadExtension = {
  [DownloadType.Pdf]: "pdf",
  [DownloadType.Excel]: "xlsx",
  [DownloadType.Csv]: "csv",
};

export const ActivePaths = {
  Applications: "/applications",
  Dashboard: "/dashboard",
  MyFinances: ["/accounts", "/cards", "/loans", "/deposits", "/stocks", "/bonds"],
  Accounts: "/accounts",
  Cards: "/cards",
  Deposits: "/deposits",
  Loans: "/loans",
  Stocks: "/stocks",
  Bonds: "/bonds",
  Banking: ["/transactions", "/templates"],
  TransactionHistory: "/history/transaction",
  ApplicationHistory: "/history/application",
  History: ["/history/transaction", "/history/application"],
  Transactions: "/transactions",
  Templates: "/templates",
  Beneficiaries: "/beneficiaries",
};

export const AccessManagementDialogContent = {
  [AccessManagementKeys.AccountTransfer]: {
    title: "accessManagement.accountTransfer.title",
    description: "accessManagement.accountTransfer.description",
  },
  [AccessManagementKeys.CardTransfer]: {
    title: "accessManagement.cardTransfer.title",
    description: "accessManagement.cardTransfer.description",
  },
};
